import type { AnswerFlagRuleResult, AnswerFlagRule } from '@app/src/types/answerFlags'
import type { RiskStatus } from '@app/src/types/resourceExplorer'
import { RISK_STATUS_DESC_ORDER } from '@app/src/utils/riskStatusHelpers'

export function compareByRiskStatus<T>(getRiskStatus: (item: T) => RiskStatus): (a: T, b: T) => number {
  return (a, b) => {
    const aIndex = RISK_STATUS_DESC_ORDER.indexOf(getRiskStatus(a))
    const bIndex = RISK_STATUS_DESC_ORDER.indexOf(getRiskStatus(b))
    return aIndex - bIndex
  }
}

export function getAnswerFlagDescription(result: AnswerFlagRuleResult): string {
  return result.answerFlagRule?.description ?? `Result #${result.id}`
}

export function formatRuleValues(rule: AnswerFlagRule): string {
  return rule.conditions?.map(condition => condition.ruleValue).join(', ') ?? ''
}

export function filterByRiskStatus<T extends { riskStatus: RiskStatus }>(
  items: T[],
  status: RiskStatus | undefined,
): T[] {
  if (!status) return []
  return items.filter(item => item.riskStatus === status)
}

export function extractAnswerFlagTitles(ruleResults: AnswerFlagRuleResult[]): string[] {
  return ruleResults.map(getAnswerFlagDescription)
}
